if(typeof window.tealium_data2track === 'undefined'){
	window.tealium_data2track = [];
}

if(typeof window.utag_data === 'undefined'){
	window.utag_data = {}
}else{
	if(typeof window.utag_data.Products === 'undefined'){
		window.utag_data.Products = []
	}
}

var rxcConfigMap = {};
var frameMap = {};
var inventoryMapRX = {};
var powerCombinedMap = {};
var roxFrameId = $("#roxFrameID").val();
var baseUrl = (isInToolkit ? '' : WCParamJS.homePageURL);
var serviceLensPack = {};
var copySelectedLens;
var skusLenses = [];
var MAX_LENSES_PER_CALL = 300;

var urlPdpParams = new URLSearchParams(window.location.search);
var isEditLenses = (urlPdpParams.get('isEditLenses') === 'true');
var isAddLenses = (urlPdpParams.get('isAddLenses') === 'true');
var lensUniqueId = urlPdpParams.get('lensUniqueId');
var frameUniqueId = urlPdpParams.get('frameUniqueId');
var frameSize = urlPdpParams.get('size');

var inputCompletePairObj = {}, resultCompletePair = {};
var addToCartInput = [];

function pdpPrescription(currentMocoAndHisSkus){
    var isRoxFrame = true;

    var moCo, skus = [],skuStdFramesMap = {}, framePartnumbers = [];
    $.each(currentMocoAndHisSkus, function( key, catentry ) {
        if (catentry.catalogEntryTypeCode == 'ItemBean'/* Only SKUs */) {
            skus.push(catentry);
            framePartnumbers.push(catentry.partNumber);
            /*$.each(catentry.merchandisingAssociations, function( key, skuStdFrameMassoc) { //get unique id from child rx frame
                if(skuStdFrameMassoc.associationType == 'ROX'){
                    skuStdFramesMap[skuStdFrameMassoc.uniqueID] = catentry;
                }
            });*/
            skuStdFramesMap[catentry.uniqueID] = catentry;
        } else {
            moCo = catentry;
        }
    });
    /*
    var framechildrenPartnumbers = roxFramePartnumbers.join("&partNumber=");
    var urlMocoRoxFrames = baseUrl + '/search/resources/store/' + WCParamJS.storeId + '/productview/byPartNumbers?partNumber=RX_' + moCo.partNumber + "&partNumber=" + framechildrenPartnumbers + "&storeId=" + WCParamJS.storeId + "&catalogId=" + WCParamJS.catalogId + "&responseFormat=json&langId=" + WCParamJS.langId + "&currency=" + WCParamJS.commandContextCurrency + (window.customerSegment != undefined ? '&customerSegment=' + customerSegment : '')  + "&profileName=LUX_findProductByPartNumber_Details&isForRXFrames=true";
    $.ajax({
        url: urlMocoRoxFrames,
        type: 'GET',
        headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache, no-store, must-revalidate"
        },
        async: true
    }).done(function(data) {
        if (data.catalogEntryView
                && data.catalogEntryView.length > 0) {
            var mocoRoxFrame = {};
            var skuRoxFrames = [];
            $.each(data.catalogEntryView, function(i, c) {
                if (c.catalogEntryTypeCode == 'ProductBean') {
                    mocoRoxFrame = c;
                } else {
                    skuRoxFrames.push(c);
                }
            });
            getMerchadisingAssociations(moCo,mocoRoxFrame,skuStdFramesMap,skuRoxFrames);
        } else {
            isRoxFrame = false;
        }
    });
    */
    getMerchadisingAssociations(moCo,skus,skuStdFramesMap);
    return isRoxFrame;

}

/* Retrieve massoc for every SKU */
function getMerchadisingAssociations(moCo,skuFrames,skuStdFramesMap){

    var frameItemBeanIdArr = [];

    $.each(skuFrames, function(skuIdx, skuFrame) {

        fn_refreshCompletePairObj(skuFrame.uniqueID,false);

        let skuStdFrame = skuStdFramesMap[skuFrame.uniqueID];
        frameItemBeanIdArr.push(skuFrame.uniqueID);
        rxcConfigMap[skuFrame.uniqueID] = {};
        powerCombinedMap[skuFrame.uniqueID] = { attributes: skuFrame.attributes };

        if(isPersol){
            $("#pdp_bottom-section").append("<span style='display:none' id='presc-lens-info__"+skuStdFrame.uniqueID +"' class='item-bean-info item-bean-id-"+skuStdFrame.uniqueID+"'>"+JSON.stringify(skuStdFrame)+"</span>");
        }else{
            $(".defining-attributes-widget").append("<span style='display:none' id='presc-lens-info__"+skuStdFrame.uniqueID +"' class='item-bean-info item-bean-id-"+skuStdFrame.uniqueID+"'>"+JSON.stringify(skuStdFrame)+"</span>");
        }
    });

    //HB-11742 prescChangeSelect() after presc-lens-info__
    productDisplayJS.prescChangeSelect();
    var mocoLensInfoMap = {};
    
    $.each(moCo.merchandisingAssociations, function(key, lensSkus) { //get massoccece from std frame parent lens ->"3074457345616902177" "3074457345616902172"
        if(lensSkus.associationType == 'ROX_COMPATIBLE_LENSES'){
            $.each(lensSkus.sKUs,function (key,singleSku) {
                skusLenses.push(singleSku.uniqueID);  //lenti figlie
                mocoLensInfoMap[lensSkus.uniqueID] = lensSkus; //mappo con id parent //meglio creare un nuovo obj ? 
            });
        }
    });
    skusLenses = skusLenses.sort(); //ordinare lista lenti figlie 
    var catalogEntryViewLenses = [];

    for (var i=0; i<skusLenses.length; i=i+MAX_LENSES_PER_CALL) {
        var skuLensesForCall = skusLenses.slice(i,Math.min(i+MAX_LENSES_PER_CALL,skusLenses.length));
        var lensChildrenIDs = skuLensesForCall.join("&id=");
        catalogEntryViewLenses = ajaxCallForLenses(lensChildrenIDs,catalogEntryViewLenses); //get all catentry lens inforamtion 
    }

    getFrameInfo(moCo,mocoLensInfoMap,frameItemBeanIdArr,skuFrames,catalogEntryViewLenses,skuStdFramesMap);
    
}
   
function getFrameInfo(moCo,mocoLensInfoMap,frameItemBeanIdArr,skuFrames,catalogEntryViewLenses,skuStdFramesMap){

    var sizeContentConfig = {}; //object for every catentry id child 

    $.each( frameItemBeanIdArr ,function( index, key ){
        sizeContentConfig[key] = {}; //key unique id
    });
            
    $.each(skuFrames, function(key,singleProduct) {

        if(singleProduct.catalogEntryTypeCode == 'ItemBean') {

            sizeContentConfig[singleProduct.uniqueID] = {
                antiReflective: singleProduct.antireflective,
                blueLight : singleProduct.blueLight,
                brand : singleProduct.brand,
                color : singleProduct.color,
                colorCategory: singleProduct.colorCategory,
                designType: singleProduct.designtype,
                polar: singleProduct.polar,
                promo: singleProduct.promo,
                thickness: singleProduct.thickness,
                transition: singleProduct.transition,
                treatment: singleProduct.treatment,
                treatmentCategory: singleProduct.treatmentCategory,
                treatmentFamily: singleProduct.treatmentFamily,
                type : singleProduct.type
            }

            frameMap[singleProduct.uniqueID] = singleProduct;

        }
    });

    createConfigObject(moCo,mocoLensInfoMap,frameItemBeanIdArr,sizeContentConfig,catalogEntryViewLenses,skuStdFramesMap);

};

function ajaxCallForLenses(lensChildrenIDs,catalogEntryViewLenses){

    var urlLensInfo = baseUrl + '/search/resources/store/' + WCParamJS.storeId + '/productview/byIds?' +  'id=' + lensChildrenIDs + "&storeId=" + WCParamJS.storeId + "&catalogId=" + WCParamJS.catalogId + "&responseFormat=json&langId=" + WCParamJS.langId + "&currency=" + WCParamJS.commandContextCurrency + "&profileName=LUX_findProductByIds_Inventory&isForInventory=true";

    $.ajax({
        url: urlLensInfo,
        type: 'GET',
        headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache, no-store, must-revalidate"
        },
        async: false
    })
    .done(function(dataLenses) {
        catalogEntryViewLenses = catalogEntryViewLenses.concat(dataLenses.catalogEntryView);
    })
    .fail(function(err) {
        console.error("Error in getting lenses info", err);
    });

    return catalogEntryViewLenses;

}

function getPackages(mocoLensInfoMap,roxSku,producttype,lensPackagesArr,skusLenses,catalogEntryViewLenses) {

    var packages = [];
    var barberiniLenses = $("#barberiniLenses").val().split(";");

    var frame = {};
    frame.offerPrice = window.customerSegment != undefined && roxSku.price['rxpricecs_'+window.customerSegment] ? roxSku.price['rxpricecs_'+window.customerSegment] : roxSku.price.rxprice;
    frame.frameDetails = {};
    frame.frameDetails.offerPrice = window.customerSegment != undefined && roxSku.price['rxpricecs_'+window.customerSegment] ? roxSku.price['rxpricecs_'+window.customerSegment] : roxSku.price.rxprice;
    frame.frameDetails.partNumber = roxSku.partNumber;
    frame.frameDetails.catEntryId = roxSku.uniqueID;

    if (lensPackagesArr.length == 0) {
    
        var parentCatalogEntryID, servicesIDArray = [], servicesMap = {};
        $.each(catalogEntryViewLenses, function(key,singleLens) {

            $.each(singleLens.merchandisingAssociations, function(key,singleAssoc){ 
                if(singleAssoc.associationType == 'ROX_COMPATIBLE_SERVICES'){
                    servicesMap[singleAssoc.uniqueID] = {};
                }
            });

        });

        $.each(Object.keys(servicesMap), function(v,k){ 
            servicesIDArray.push(k);
        });

        if(servicesIDArray.length > 0){
            var servicesIDs = servicesIDArray.join("&id=");
            urlLensInfo = baseUrl + '/search/resources/store/' + WCParamJS.storeId + '/productview/byIds?' +  'id=' + servicesIDs + "&storeId=" + WCParamJS.storeId + "&catalogId=" + WCParamJS.catalogId + "&responseFormat=json&langId=" + WCParamJS.langId + "&currency=" + WCParamJS.commandContextCurrency + "&profileName=LUX_findProductByIds_Inventory&isForRXServices=true";
            
            $.ajax({
                url: urlLensInfo,
                type: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache, no-store, must-revalidate"
                },
                async: false
            })
            .done(function(dataServices) {
            
                $.each(dataServices.catalogEntryView, function(key,singleService) {
                    servicesMap[singleService.uniqueID] = singleService;
                });

                $.each(catalogEntryViewLenses, function(key,singleLens) {

                    parentCatalogEntryID = singleLens.parentCatalogEntryID;
                    //  To prevent dirty data: sometimes Lenses ItemBean linked to ROX Frame ItemBean not correspond to the parents
                    if (mocoLensInfoMap[parentCatalogEntryID]) {
                        var lensPackage = fillInLensPackage(singleLens,servicesMap,parentCatalogEntryID,mocoLensInfoMap,barberiniLenses,producttype);
                        packages.push({frame,lensPackage});
                        lensPackagesArr.push(lensPackage);
                    }
                    
                });

                //  Plano frame
                if (producttype === 'optical') {
                    var lensPackage = {
                        "blueLight": null,
                        "catEntryId": "-1",
                        "productUPC": "Plano",
                        "transition": null,
                        "type": "Frame Only",
                        "uvProtection": null,
                        "antiScratch": null,
                        "color": null,
                        "listPrice": "0.00",
                        "offerPrice": "0.00",
                        "insPrice": null,
                        "brand": isPersol ? "Persol" : "Oliver Peoples",
                        "thickness": 'Thin',
                        "isBaseLens": null,
                        "antiReflective": null,
                        "upc": "99",              // UPC/identifier of the plano lens
                        "insurable": false,
                        "rxValues": null
                    };
                    packages.push({frame,lensPackage});
                    lensPackagesArr.push(lensPackage);
                }

            })
            .fail(function(err) {
                console.error("Error in getting services info", err);
            });
        }

    } else {

        $.each(lensPackagesArr, function(i,lensPackage) {
            packages.push({frame,lensPackage});
        });

    }

    return packages;

}


function fillInLensPackage(singleProduct,servicesMap,parentCatalogEntryID,mocoLensInfoMap,barberiniLenses,producttype) {

    var lensPackage = {};
    
    //  Lens ProductBean
    lensPackage.blueLight  = getAttributeIdentifier(mocoLensInfoMap[parentCatalogEntryID].attributes,"ANTI_BLUE");
    lensPackage.antiReflective = getAttributeIdentifier(mocoLensInfoMap[parentCatalogEntryID].attributes,"ANTI_REFLECTIVE");
    lensPackage.treatment  = getAttributeIdentifier(mocoLensInfoMap[parentCatalogEntryID].attributes,"LENS_TREATMENT");
    lensPackage.color  =  getAttributeIdentifier(mocoLensInfoMap[parentCatalogEntryID].attributes,"LENS_COLOR_FACET");
    lensPackage.thickness  = getAttributeIdentifier(mocoLensInfoMap[parentCatalogEntryID].attributes,"LENS_THICKNESS");
    lensPackage.polar = stringToBoolean(getAttributeIdentifier(mocoLensInfoMap[parentCatalogEntryID].attributes,"POLARIZED"));
    lensPackage.lensMaterial  = getAttributeIdentifier(mocoLensInfoMap[parentCatalogEntryID].attributes,"LENS_MATERIAL");
    lensPackage.designType  = getAttributeIdentifier(mocoLensInfoMap[parentCatalogEntryID].attributes,"LENS_DESIGN");
    lensPackage.transition  = getAttributeIdentifier(mocoLensInfoMap[parentCatalogEntryID].attributes,"TRANSITION_TYPE");
    lensPackage.clen = getAttributeIdentifier(mocoLensInfoMap[parentCatalogEntryID].attributes,"CLEN");
    if (lensPackage.clen != undefined && lensPackage.clen != null) {
        lensPackage.clen = lensPackage.clen.toUpperCase();
    }
    lensPackage.antiScratch  = stringToBoolean(getAttributeIdentifier(mocoLensInfoMap[parentCatalogEntryID].attributes,"ANTI_SCRATCH"));
    lensPackage.uvProtection  = stringToBoolean(getAttributeIdentifier(mocoLensInfoMap[parentCatalogEntryID].attributes,"UV_PROTECTION"));
    lensPackage.colorCategory  = getAttributeIdentifier(mocoLensInfoMap[parentCatalogEntryID].attributes,"LENS_TREATMENT_FACET");

    //  Lens SKU
    lensPackage.offerPrice = singleProduct.price.price;
    if (producttype === 'sun') {
        lensPackage.treatment = null;
        lensPackage.transition = null;
    } else if (producttype === 'optical') {
        if ((lensPackage.color && lensPackage.color.startsWith("Clear")) || lensPackage.color === "Demo Lens" || lensPackage.color === "Transparent" || lensPackage.color === ""){
            lensPackage.color = null;
            lensPackage.treatment = null;
            lensPackage.transition = null;
        }
    }
    var photochromic = getAttributeIdentifier(mocoLensInfoMap[parentCatalogEntryID].attributes,"PHOTOCHROMIC").toLowerCase();
    if (photochromic === "true"){
    	lensPackage.treatmentFamily = "Transitions";
    }
    lensPackage.productUPC  = singleProduct.partNumber;
    lensPackage.suitableForDiving = null;
    var correctiontype = getAttributeIdentifier(singleProduct.attributes,"CORRECTIONTYPE").toLowerCase();
    if (correctiontype != undefined && correctiontype != null) {
        if(correctiontype != 'non_prescription'){
            correctiontype = correctiontype.replaceAll('_',' ');
        }
        correctiontype = correctiontype.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
    }
    lensPackage.type  = correctiontype;
    lensPackage.recommendedUse  = null;
    lensPackage.catEntryId  = singleProduct.uniqueID;
    lensPackage.brand  = barberiniLenses.includes(singleProduct.partNumber) ? "Barberini" : (isPersol ? "Persol" : "Oliver Peoples");
    lensPackage.upc  = singleProduct.partNumber;
    lensPackage.isBaseLens  = true;
    lensPackage.insurable  = false;

    lensPackage.rxValues =  {};
    lensPackage.rxValues.sph = {
        min:  getAttributeValue(singleProduct.attributes,"POWER_SPHERE_MIN"),
        max:  getAttributeValue(singleProduct.attributes,"POWER_SPHERE_MAX"),
    };
    lensPackage.rxValues.cyl =  {
        min:  getAttributeValue(singleProduct.attributes,"POWER_CYLINDER_MIN"),
        max:  getAttributeValue(singleProduct.attributes,"POWER_CYLINDER_MAX"),
    };
    lensPackage.rxValues.add = null/*{
        "min": "",
        "max": ""
    }*/;

    if(lensPackage.type === "Progressive"){
        lensPackage.rxValues.add =  {
            "min": "+0.75",
            "max": "+3.50"
        }
    }
    lensPackage.promo = null;
    lensPackage.listPrice  = singleProduct.price.listprice;
    lensPackage.lensPackageDetails = {};
    lensPackage.lensPackageDetails.lens = {};
    lensPackage.lensPackageDetails.lens.catEntryId = singleProduct.uniqueID;
    lensPackage.lensPackageDetails.lens.name = singleProduct.name;
    lensPackage.lensPackageDetails.lens.partNumber = singleProduct.partNumber;
    lensPackage.lensPackageDetails.lens.offerPrice = singleProduct.price.price;
    lensPackage.lensPackageDetails.services = [];

    $.each(singleProduct.merchandisingAssociations, function(key,singleAssoc){ 
        if(singleAssoc.associationType == 'ROX_COMPATIBLE_SERVICES'){

            var service = servicesMap[singleAssoc.uniqueID];
            
            lensPackage.lensPackageDetails.services.push({
                catEntryId: service.uniqueID,
                name: service.name,
                partNumber: service.partNumber,
                offerPrice: service.price.price
            });
            serviceLensPack[service.uniqueID] = {
                catEntryId: service.uniqueID,
                name: service.name,
                partNumber: service.partNumber,
                offerPrice: service.price.price
            };

            //frame + all services prices
            lensPackage.offerPrice = (parseFloat(lensPackage.offerPrice) + parseFloat(service.price.price)).toFixed(1); //frame + service
            lensPackage.listPrice = (parseFloat(lensPackage.listPrice) + parseFloat(service.price.listprice)).toFixed(1); // frame +service

        }
    });

    return lensPackage;

}

/**
* This function, after clicking Edit Lenses in the shopping cart, 
* shows in PDP the frame size previously selected by the user.
*
*/
function showActualSelectedSizeInPDP() {
    $('.size-option-div ul li').not('.soldOut').each(function(index){
        if(frameSize == $('.size-option-div ul li')[index].attributes["data-option"].value) {
            $(this).click();
        } 
    });
}

function createConfigObject(moCo,mocoLensInfoMap,frameItemBeanIdArr,sizeContentConfig,catalogEntryViewLenses,skuStdFramesMap){

    var producttype = getAttributeValue(moCo.attributes,"PRODUCTTYPE").toLowerCase();
    var frameImageUrl = moCo.thumbnail2;
    try {
        if (producttype === 'optical') {
            var shadQtArr = moCo.manifest.payload.images.filter(el => el.usage == 'PDP Carousel' && el.path.includes('__shad__qt'));
            if (shadQtArr.length > 0) {
                frameImageUrl = shadQtArr[0].path;
                if (isPersol) {
                    frameImageUrl += '?impolicy=HB_parameters&sclw=0.8&sclh=0.8';
                }
            }
        }
    } catch (e) {
        console.error('Error in getting shadow image',e);
    }

    var lensPackagesArr = [];
    $.each(frameItemBeanIdArr, function( index, key ){
        var packages = getPackages(mocoLensInfoMap,frameMap[key],producttype,lensPackagesArr,skusLenses,catalogEntryViewLenses);
        rxcConfigMap[key] = {
            selector: "#rxcApp",
            lensesData: { 
                packages
            },
           
            
            actionsModule: { 
                genericAddToCart: function (_frameObject, _lensObject, _warrantyObject, _reviewObject, _imagery) {
                    //If isAddLenses eq true: deletes the item involved and replaces it with a new item containing the new lens configuration.
                    if(isAddLenses) {

                        addToCartInput.frameObject = _frameObject;
                        addToCartInput.lensObject = _lensObject;
                        addToCartInput.warrantyObject = _warrantyObject;
                        addToCartInput.reviewObject = _reviewObject;
                        addToCartInput.imagery = _imagery;
                        addToCartInput.merchandisingAssociations = frameMap[key].merchandisingAssociations;

                        var params = [];
                        params.storeId = WCParamJS.storeId;
                        params.catalogId = WCParamJS.catalogId;
                        params.langId = WCParamJS.langId;
                        params.orderId = urlPdpParams.get('orderId');
                        params.orderItemId = urlPdpParams.get('orderItemId');
                        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
                        params.check = "*n";
                        params.calculateOrder = "1";

                        wcService.invoke("AjaxDeleteOrderItem", params);   
                    } else {
                        fn_ext_genericAddToCart(_frameObject, _lensObject, _warrantyObject, _reviewObject, _imagery, frameMap[key].merchandisingAssociations);
                    }
                },

                /**
                 * This function saves the current user choices after the edit lenses from cart action,
                 * deleting the item involved and replacing it with a new item containing the new lens configuration.
                 *
                 */
                genericSaveEditFromCart: function (_frameObject, _lensObject, _warrantyObject, _cartMode, _reviewObject, _imagery) {

                    addToCartInput.frameObject = _frameObject;
                    addToCartInput.lensObject = _lensObject;
                    addToCartInput.warrantyObject = _warrantyObject;
                    addToCartInput.reviewObject = _reviewObject;
                    addToCartInput.imagery = _imagery;
                    addToCartInput.merchandisingAssociations = frameMap[key].merchandisingAssociations;

                    var params = [];
                    params.storeId = WCParamJS.storeId;
                    params.catalogId = WCParamJS.catalogId;
                    params.langId = WCParamJS.langId;
                    params.orderId = urlPdpParams.get('orderId');
                    params.orderItemId = _cartMode.orderItemId;
                    params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
                    params.check = "*n";
                    params.calculateOrder = "1";

                    wcService.invoke("AjaxDeleteOrderItem", params);
                },

                genericSaveLensSelection: undefined,
                loadLearnMoreContent: function(e) {
                    var l = "/wcs/resources/store/" + WCParamJS.storeId + "/espot/" + e;
                    return new Promise((function(e, n) {
                        var r = new XMLHttpRequest;
                        r.onload = function() {
                            new Response(r.response,{
                                status: 200
                            }).json().then((function(l) {
                                if (l.MarketingSpotData && l.MarketingSpotData.length > 0 && l.MarketingSpotData[0].baseMarketingSpotActivityData && l.MarketingSpotData[0].baseMarketingSpotActivityData.length > 0 && l.MarketingSpotData[0].baseMarketingSpotActivityData[0].marketingContentDescription && l.MarketingSpotData[0].baseMarketingSpotActivityData[0].marketingContentDescription.length > 0 && l.MarketingSpotData[0].baseMarketingSpotActivityData[0].marketingContentDescription[0].marketingText) {
                                    let n = l.MarketingSpotData[0].baseMarketingSpotActivityData[0].marketingContentDescription[0].marketingText;
                                    e(n)
                                }
                            }
                            ))
                        }
                        ,
                        r.onerror = function() {
                            n(new TypeError("Local request failed"))
                        }
                        ,
                        r.open("GET", l),
                        r.responseType = "arraybuffer",
                        r.send(null)
                    }
                    ))
                },
                loadContent: function (_loadContentName) {
            
                },
                genericExit: function () {
                    $(".fade-prescription").hide();
                    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
                        if($.scrollify) $.scrollify.enable();
                        managePopupTabIndex(".presc--body", false);
                    } else {
                        manageScrollOverlay(false);
                    }

                    if(isPersol){ 
                        $("html").removeClass("overflow-hidden");    	 
                    } else{
                        $("body").removeClass("overflow-hidden");
                        $("body").css("position", "relative");
                        if (typeof vmSwitchOff === 'function') {
                            vmSwitchOff(false);
                        }
                    }
                    $("#page-overflow-wrapper").removeClass("overflow-hidden");
                    $('#draggable-cta-section').removeClass("overflow-hidden");
                }
            },
            data: {
                "langId": WCParamJS.langId,
                "storeId": WCParamJS.storeId,
                frame: {
                    catEntryId: key,
                    name: moCo.name,
                    upc: frameMap[key].partNumber != undefined && frameMap[key].partNumber != null ? frameMap[key].partNumber : undefined,
                    partNumber: frameMap[key].partNumber,
                    color: moCo.partNumber.split('__')[1],
                    model: moCo.partNumber.split('__')[0],
                    listPrice:  frameMap[key].price.rxlistprice,
                    offerPrice: window.customerSegment != undefined ?  frameMap[key].price['price_'+window.customerSegment] : frameMap[key].price.rxprice,
                    brand: "",//Object.keys(frameMap[key].brand)[0],
                    imageUrl: isPersol ? frameImageUrl.replace('&sclw=0.25&sclh=0.25','&sclw=0.8&sclh=0.8') : frameImageUrl.split('?')[0]+'?bg=f8f8fb&impolicy=OV_parameters&sclw=0.8&sclh=0.8',
                    size: defaultValue(getAttributeValue(powerCombinedMap[key].attributes,"MODEL_SIZE_DISPLAY"),'Standard') + " "+ getConvertedDistance(getAttributeValue(powerCombinedMap[key].attributes,"HINGE_DISTANCE")),
                    category: frameMap[key].category_type,
                    rxValues: {
                        // prescription power max and min values, MANDATORY for prescription filtering feature
                        powerCombinedMin: defaultValue(getAttributeValue(powerCombinedMap[key].attributes,"POWER_COMBINED_MIN"),'-99'),
                        powerCombinedMax: defaultValue(getAttributeValue(powerCombinedMap[key].attributes,"POWER_COMBINED_MAX"),'+99')
                    }
                },
                frameOnlyLensUPC: "99",
                showFrameOnly: producttype === 'optical',
                //lens: isEditLenses && frameUniqueId == key ? { catEntryId: lensUniqueId } : undefined
                lens: isEditLenses ? { catEntryId: lensUniqueId } : undefined
            },
            dynamicPromoModule: {
                getDiscounts : function (_selectedFrame, _selectedData) {
                    // Similarly as the insurance module, this call is used to
                    // modify the offerPrice values in order to show the PST.
                    // _selectedFrame contains data.frame.*
                    // _selectedData contains lensData.*
                    // Here below an example code

                    return new Promise(function (resolve, reject) {
                        if (typeof resultCompletePair === 'undefined'
                                || typeof resultCompletePair[_selectedFrame.catEntryId] === 'undefined') {
                            fn_refreshCompletePairObj(_selectedFrame.catEntryId,false);
                        }
                        var copySelectedLens = JSON.parse(JSON.stringify(_selectedData));
                        for (var i = 0; i < copySelectedLens.packages.length; i++) {
                            try {
                                if (typeof resultCompletePair !== 'undefined'
                                        && typeof resultCompletePair[_selectedFrame.catEntryId] !== 'undefined'
                                        && typeof resultCompletePair[_selectedFrame.catEntryId][copySelectedLens.packages[i].lensPackage.catEntryId] !== 'undefined'
                                        && resultCompletePair[_selectedFrame.catEntryId][copySelectedLens.packages[i].lensPackage.catEntryId].hasPromotion){
                                    var amoutWithoutCompletePair = parseFloat(copySelectedLens.packages[i].lensPackage.offerPrice) + parseFloat(copySelectedLens.packages[i].frame.offerPrice)
                                    
                                    var discountOnFrameRx = amoutWithoutCompletePair - parseFloat(resultCompletePair[_selectedFrame.catEntryId][copySelectedLens.packages[i].lensPackage.catEntryId].offerPrice);
                                    
                                    var priceWithDiscount = parseFloat(copySelectedLens.packages[i]['frame']['offerPrice']) - discountOnFrameRx;
                                    var priceWithDiscountFrameDetails = parseFloat(copySelectedLens.packages[i]['frame']['frameDetails']['offerPrice']) - discountOnFrameRx;

                                    console.log("Price without Completepair (Lens+FrameRX): " + copySelectedLens.packages[i].lensPackage.productUPC + " + "+copySelectedLens.packages[i].frame.frameDetails.partNumber + " = (" + copySelectedLens.packages[i].lensPackage.offerPrice + ") + (" + copySelectedLens.packages[i].frame.offerPrice + ") = " + amoutWithoutCompletePair);
                                    
                                    if(discountOnFrameRx > 0){
                                        var priceTotalDiscounted = parseFloat(copySelectedLens.packages[i].lensPackage.offerPrice) + priceWithDiscountFrameDetails
                                        console.log("Completepair activated: (Lens+FrameRX): " + copySelectedLens.packages[i].lensPackage.productUPC + " + "+copySelectedLens.packages[i].frame.frameDetails.partNumber + " = (" + copySelectedLens.packages[i].lensPackage.offerPrice + ") + (" + priceWithDiscountFrameDetails + ") = " + priceTotalDiscounted);
                                    }

                                    copySelectedLens.packages[i]['frame']['frameDetails']['offerPrice'] = priceWithDiscountFrameDetails.toFixed(1);
                                    copySelectedLens.packages[i]['frame']['offerPrice'] = priceWithDiscount.toFixed(1);
                                    
                                }
                            } catch (e) {
                                console.error('Error in completepair loop: '+JSON.stringify(e));
                            }
                        }
                        resolve({
                            frame: _selectedFrame, 
                            lensesData: copySelectedLens
                        });
                    });
                },
            },
            brand: brandName.toLocaleLowerCase(),
            layoutSettings : {
            	enableLargeIcons:true,
                enableNestedTransitionSwatch: true,
            	enableDigitalOptometry: true,
            	targetDigitalOptometry: ['Single Vision'],
                activateMoneySavingsBadge: $('#discountBadgeActive').length > 0 ? $('#discountBadgeActive').val() : false,
            },
            baseURLs: {
                projectImage: isPersol ? "https://assets.persol.com/extra/image/rxc/brands/persol/" :"https://assets.oliverpeoples.com/extra/image/rxc/brands/oliverpeoples/",
                framesImage: isPersol ? "https://assets.persol.com/is/image/Persol" : "https://assets.oliverpeoples.com/is/image/OliverPeoples",
                assetsCDN: isPersol ? "https://assets.persol.com" : "https://assets.oliverpeoples.com",
                genericImage: isPersol ? "https://assets.persol.com/extra/image/rxc/brands/persol/" : "https://assets.oliverpeoples.com/extra/image/rxc/brands/oliverpeoples/"
            },
            translation: {
                language: $("#rxcLocale").val()
            },
            prescriptionModule: {
                prescriptionType: "FULL",
                prescriptionFlows: ["MANUAL", "UPLOAD"],
                fileExtensions: ["png", "gif", "jpeg", "tiff", "bmp", "word", "pdf"],
                maxFileSize: 10,
                hideMoreOptions: true,
                loadPrescription: function () {  
                    //Available from 7.x+ (v5)
                    return new Promise(function (resolve, reject) {
                        resolve(_prescriptionObject);
                    });
                },
                savePrescription: function (_prescriptionObject) {
                    console.log(
                        'Calling savePrescription()\n\nPrescription object: ' +
                         JSON.stringify(_prescriptionObject)
                    );
                    //sample cookie saving
                     document.cookie = '_prescriptionObject=' + JSON.stringify(_prescriptionObject);

                    return true; // or false if failure
                },
                checkAvailableFrames: function (_frame, _prescriptionObject) {
                    console.log(
                            'Calling checkAvailableFrames().\n\nFrame object: ' +
                                JSON.stringify(_frame) +
                                '\n\nPrescription object: ' +
                                JSON.stringify(_prescriptionObject)
                        );
                        var filteredFramesURL = null;
                        return filteredFramesURL;
            
                },
                clearPrescription: function () {
                    $.removeCookie("_prescriptionObject");
                    return true;
                },
                loadExtendedPrescription: function (_requestObject) {
                    return new Promise(function (resolve, reject) {
                        var _prescriptionObject = null;
                        var value = null;

                        // example cookie name
                        var name = "_prescriptionObject=";

                        // take current client cookies
                        var decodedCookie = decodeURIComponent(document.cookie);
                        var ca = decodedCookie.split(';');

                        // iterate until our cookie name is found
                        for(var i = 0; i <ca.length; i++) {
                            var c = ca[i];
                            while (c.charAt(0) == ' ') {
                                c = c.substring(1);
                            }
                            if (c.indexOf(name) == 0) {
                            value = c.substring(name.length, c.length);
                            }
                        }

                        // if cookie value is found, we try to parse it and set the _prescriptionObject
                        if(value){
                            try{
                                _prescriptionObject = JSON.parse(value)
                            }catch(e){
                                console.log(e);
                            }
                        }

                        console.log('Calling loadPrescription()\n\nPrescription object: '+ JSON.stringify(_prescriptionObject));

                        // validation is run by the configuration agains the return object
                       resolve(_prescriptionObject);
                    }).catch(function(error) {
                        reject(error);
                    });;
                },
                uploadExtendedPrescription: function (_requestObject) {
                   return new Promise(async function (resolve, reject) {
                        /*
                            the db istance is is created here because
                            the function have to resolve the promise
                            with prescriptionId. Next, the function
                            saveExtendedPrescription is called, that will
                            update the instance with the pd value
                        */
                       
                        userId = $.cookie("_userId");
                        if (userId == undefined){

                            userId = getUserId();
                            if (userId == "-1002") {userId = setUserIdentity();}

                        }
                        var inputFile = await urltoFile(_requestObject.fileData, _requestObject.fileName);
                        var parameters = {};
                      
                        parameters.storeId= WCParamJS.storeId;
                        parameters.langId= WCParamJS.langId;
                        parameters.catalogId= WCParamJS.catalogId;
                        parameters.fileDate= inputFile.lastModified;
                        parameters.evidence=  inputFile.name;
                        parameters.userId = userId;

                        var docStr = generateXML(parameters);
                        var xmldoc = {};
                        xmldoc.XML = docStr;

                        prescriptionid = await AddPrescription(xmldoc);
                        await addFilePrescription(inputFile,prescriptionid,"upload"); 
                        
                        _responseObject  = {};
                        _responseObject.prescriptionId = prescriptionid;
                        _responseObject.fileName = inputFile.name.split(".")[0];
                        _responseObject.fileData = _requestObject.fileData
                        _responseObject.savedFileName = "PID" + prescriptionid + "__" + inputFile.name.split(".")[0] + "__" + inputFile.lastModified + "." + inputFile.name.split(".")[1];
                         document.cookie = "_userId=" + userId;

                        resolve(_responseObject);
                    }); 
                },
                saveExtendedPrescription: function (_prescriptionObject) {
                    // Available from 7.x+ (v5)
                    return new Promise(async function (resolve, reject) {
                        userId = $.cookie("_userId");
                        if (userId == undefined){

                            userId = getUserId();
                            if (userId == "-1002") {userId = setUserIdentity();}

                        }

                        var parameters = {};
                        parameters.storeId= WCParamJS.storeId;
                        parameters.langId= WCParamJS.langId;
                        parameters.catalogId= WCParamJS.catalogId;
                        if(_prescriptionObject.prescriptionFlow == 'UPLOAD'){
                            
                           parameters.prescriptionId= _prescriptionObject.prescriptionId;

                            //BEGIN HB-10828 
                            //if user go back from manual prescription to upload image the manual prescription has to be erased
                                parameters.rightSphere = "";
                                parameters.leftSphere = "";

                                parameters.rightCyl = "";
                                parameters.leftCyl = "";

                                if(_prescriptionObject.AX != null){
                                    parameters.rightAxis = "";
                                    parameters.leftAxis = "";
                                }
                            
                                if(_prescriptionObject.ADD != null){
                                    parameters.rightAdd = "";
                                    parameters.leftAdd = "";
                                }
                            //END HB-10828
                        }
                        parameters.userId = userId;
                        if(_prescriptionObject.prescriptionFlow == 'MANUAL'){
                            
                            //BEGIN HB-10828 
                            //if user go back from upload image to a manual prescription than the reference to the file has to be erased
                                parameters.evidence = "";
                            //END HB-10828

                            parameters.rightSphere = _prescriptionObject.SPH.OD;
                            parameters.leftSphere = _prescriptionObject.SPH.OS;

                            parameters.rightCyl = _prescriptionObject.CYL.OD;
                            parameters.leftCyl = _prescriptionObject.CYL.OS;

                            if(_prescriptionObject.AX != null){
                                parameters.rightAxis = _prescriptionObject.AX.OD;
                                parameters.leftAxis = _prescriptionObject.AX.OS;
                            }
                           
                            if(_prescriptionObject.ADD != null){
                                parameters.rightAdd = _prescriptionObject.ADD.OD;
                                parameters.leftAdd = _prescriptionObject.ADD.OS;
                            }


                        }
                        parameters.rightPD = _prescriptionObject.PD.OD;
                        parameters.leftPD = _prescriptionObject.PD.OS;

                        if (parameters.leftPD == null){
                            parameters.rightPD = Math.trunc(_prescriptionObject.PD.OD / 2);
                            parameters.leftPD = Math.trunc(_prescriptionObject.PD.OD / 2);
                        }

                        
          
                        var docStr = generateXML(parameters);
                        var xmldoc = {};
                        xmldoc.XML = docStr;

                        prescriptionid = await AddPrescription(xmldoc);
                        _prescriptionObject.prescriptionId = prescriptionid;

                        
                        document.cookie = "_prescriptionObject=" + JSON.stringify(_prescriptionObject);
                        document.cookie = "_userId=" + userId;
                        
                        resolve(_prescriptionObject);
                    });
                },
                downloadExtendedPrescription: function (savedFileName) {
                    return new Promise( function (resolve, reject) {

                        var prescriptionid = savedFileName.savedFileName.split("__")[0].substring(3);
                        downloadFilePrescription(savedFileName.savedFileName,prescriptionid).then(function(filedata){
                            prescriptionObject = {};
                            prescriptionObject.fileData = filedata;
                            resolve(prescriptionObject);
                        });
                    });
                },
                clearExtendedPrescription: function (_requestObject) {
                    // Available from 7.x+ (v5)
                    return new Promise(function (resolve, reject) {
                        $.removeCookie("_prescriptionObject");
                        resolve({});
                    });
                }
            },
            currencyFormat: {
                thousandSeparator: WCCurrencyJS.thouSep, 
                decimalSeparator: WCCurrencyJS.decSep,
                decimalScale: WCCurrencyJS.decimal, 
                prefix: WCCurrencyJS.symbolUNI
            },
            //BEGIN HB-11366: was requested to show only klarna
            /*paymentInstallment: affirmEnabled === 'true' || klarnaEnabled === 'true' ? {
                "type": affirmEnabled === 'true' ? 'affirm' : 'klarna',*/
            paymentInstallment: klarnaEnabled === 'true' ? {
                "type": 'klarna',
                "installments": 4,
                "multiplePaymentInstallment": false
            } : undefined,
            //END HB-11366
            cartMode: isEditLenses
                ? {
                    orderItemId: urlPdpParams.get('orderItemId'),
                    orderIndex: urlPdpParams.get('orderIndex')
                } : undefined
        };

        rxcConfigMap[key].lensesData['content'] = sizeContentConfig[key];

        //  Complete Pair
        inputCompletePairObj[key] = {};
        for (var i = 0; i < packages.length; i++) {
            try {
                if (packages[i].lensPackage.catEntryId != -1) {
                    var arrayServices = [];
                    for (var j = 0; j < packages[i].lensPackage.lensPackageDetails.services.length; j++) {
                        arrayServices.push(packages[i].lensPackage.lensPackageDetails.services[j].catEntryId);
                    }
                    inputCompletePairObj[key][packages[i].lensPackage.catEntryId] = {};
                    inputCompletePairObj[key][packages[i].lensPackage.catEntryId]['services'] = arrayServices;
                }
            } catch (e) {
                console.error('Error in completepair loop: '+JSON.stringify(e));
            }
        }

    });

    /* BEGIN - Edit Lenses in cart */
    if(isEditLenses || isAddLenses) {
        $('#roxLenses').val(frameUniqueId);
        fn_manageRXCOpening();
    }
    /* END - Edit Lenses in cart */

}

function fn_refreshCompletePairObj(frameId,myAsync) {

    //  Getting the promo info only for the first frame
    //  because for the other frames they will be identical
    if (Object.keys(resultCompletePair).length == 0) {

        var inputCP = 'frameId='+frameId;
        var completePairService = WCParamJS.urlPrefixForHTTPS + "/wcs/resources/store/" + WCParamJS.storeId + "/promo/completepair/price";
        $.ajax({
            type: "GET",
            async : myAsync,
            url: completePairService,
            data: inputCP,
            contentType: "application/json",
            success: function (result) {
                resultCompletePair[frameId] = result['completePairs'][frameId];
            },
            error: function (result, status) {
                console.error('Error in completepair service: '+JSON.stringify(result));
            }
        });

    } else {
        resultCompletePair[frameId] = resultCompletePair[Object.keys(resultCompletePair)[0]];
    }

}

function fn_lensConfigurator(config){
    var myWidget = RXC.rxcWidget.new(config);
    
    if (typeof Promise.each == 'undefined') 
    {
        $.loadScriptByUrl('/wcsstore/Common/ThirdPartyLibraries/bluebird/bluebird.min.js', function(){
            console.log("Reloading bluebird");
            myWidget.render();
        });
        
    }else{
        myWidget.render();
    }
};

function fn_initLensConfigurator() {

    var isRoxFrame = pdpPrescription(inventoryMapNew);

    if (isRoxFrame) {

		if($("#oneSizeOnly").length >0){
			var catentryIdPresc = sizeCatentryMap[sizeNameEN];
		} else if ($("#oneSizeOnly").length == 0) {
			var catentryIdPresc = modelSizeCatentryMap[modelSize];
		}
		var sizeWithPresc = $("input#sizeHasPresc_"+catentryIdPresc).val();
        var productTypePDP = $('#productTypePDP').val();

        if (window.innerWidth > 768 && window.innerWidth > window.innerHeight) {      
            if (isOliver){    
                $("#pdp-presc-and-clip-on").prepend($("#presc--button"));
            } else {
                $(".monogram-cbs-container").after($("#presc--button"));
            }
            
            if($("#presc--button").is(':visible')){ 
                if(brand == 'Oliver') {
                    $("#pdp-presc-and-clip-on").css({'border-left': '3px solid white'});
                }
            } else{
                $('#pdp_other_colors, .full-image-widget').addClass('no-prescription');
            }
        } 

        if(isOliver && productTypePDP.toLowerCase() == 'sun' && (typeof sizeWithPresc != 'undefined' && sizeWithPresc.toLowerCase() === 'true')){
            if(isPreOrderActive && checkPreorderUpc()) {
                $("#presc--button").hide(); 
            }
            else {
                $("#presc--button").show();
            }
        }

        if(isAddLenses) {
            $("#presc--side--button,#Select_lenses_CTA").click(fn_manageRXCOpening);
        } else {
            $("#presc--side--button,#Select_lenses_CTA,.selectLensesButton").click(fn_manageRXCOpening);
        }

        /* BEGIN - Frame Advisor 2.0 */
        if (typeof fn_openRXConfiguratorCallback === 'function') {
            fn_openRXConfiguratorCallback();
        }
        /* END - Frame Advisor 2.0 */

    }
    hideCTALoader('presc--side--button'); 
    hideCTALoader('add2CartBtn'); //hide loaderLensConfigurator once all is ready
    hideCTALoader('addLenses');
    hideCTALoader('productPageAdd2Cart'); 
    showActualSelectedSizeInPDP();
}

function fn_manageRXCOpening() {
    if ($.cookie("isVMOpen") == "1" && !$('#vm_box').hasClass('hide')) {
        if (typeof vmSwitchOff === 'function') {
        vmSwitchOff(false);
    }
    }
    if (($('#close-prescriptions').attr('href') == undefined)){
        $('#close-prescriptions').attr('href','#');
    }
    
    $(".fade-prescription").show();
    $("#lensOptionTypeChoice1").prop("checked", true);

    if (isPersol || isOliver){
        //If CHOOSE YOUR LENS is clicked
        if ($(this).attr("id") == "addLenses") {
            showCTAloader("addLenses");
            setTimeout(function() {
                hideCTALoader("addLenses");
            }, 2000)
        } else if ($(this).attr("id") == "presc--side--button"){
            //If ADD A PRESCRIPTION cta is clicked
            showCTAloader("presc--side--button");
            setTimeout(function() {
                hideCTALoader("presc--side--button");
            }, 2000)
        }
    }

    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
        if($.scrollify) $.scrollify.disable();
        //managePopupTabIndex(".presc--body", true);
    } else {
        manageScrollOverlay(true);
    }
    // $('.bottom-scrollable-section').css('z-index', "1000"); 
    if(isPersol){ 
        $("html").addClass("overflow-hidden");    	 
    } else{
        $("body").addClass("overflow-hidden");
        $("body").css("position", "relative");
        if (typeof vmSwitchOff === 'function') {
            vmSwitchOff(false);
        }
    }
    $("#page-overflow-wrapper").addClass("overflow-hidden");
    $('#draggable-cta-section').addClass("overflow-hidden");
    
    var curretFrameStd = $('#roxLenses').val();

    fn_lensConfigurator(rxcConfigMap[curretFrameStd]);
}

function fn_ext_genericAddToCart(_frameObject, _lensObject, _warrantyObject, _reviewObject, _imagery, massoc) {

    productDisplayJS.usingLensConfigurator = true;

    if(_lensObject.lensPackage.productUPC != 'Plano'){ 
        //do not execute when adding to cart only frame
        productDisplayJS.AddPrescriptionToItem(_lensObject.lensPackage.thickness,_lensObject.lensPackage.type,_lensObject.lensPackage.thickness,_lensObject.lensPackage.catEntryId);
    }else{
        productDisplayJS.isFrameOnly = true;
    }
    var item = "entitledItem_";

    //find the standard frame uniqueID because in the command search the uniqueID of massoc
    item = item + _frameObject.catEntryId;
 
 
    //BEGIN HB-10578

    var state = {}
    var urlProduct = window.location.href.split("?")[0];
    history.pushState(state, '', urlProduct);

    //END HB-10578
    
    productAdd2Cart(item);                    
}

//BEGIN handle backend add prescription 

//function for generating an xml from js dictionary
function generateXML(parameters){
    
    var str = '<?xml version="1.0" encoding="UTF-8"?>\n';
    var str = str + '<XML>\r\n';
        for (const [key, value] of Object.entries(parameters)) {
        //console.log(key + ":" + value);
        str = str + "<" + key + ">" + value +"</" + key + ">\r\n";
        }
        
        var str = str + '</XML>\r\n';
        console.log(str);
        return str;
}

//function for a generic ajax call
function ajaxcall(url,meth,postdata,isFile){
    return new Promise((resolve, reject) => {
        var obj = {
        url: url,
        method: meth,
        //dataType: dataType,
        data: postdata,
        async: false,
        success: function(data) {
                console.log("resolved");
            resolve(data);
            
        },
        error: function(err) {
            console.log("rejected");
            reject(err);
        }
    };
    if(isFile){
    obj.processData = false;
    obj.contentType = false;
    }
    $.ajax(obj);
});
}
   
//function to convert base64 file in an object for the command
async function urltoFile(url, filename, mimeType){
   
      let res = await fetch(url);
      let buf  = await res.arrayBuffer();
      let fileObject = new File([buf], filename,{type:mimeType});
   return fileObject;
}

//function for add/modify the prescription
function addFilePrescription(inputFile, prescriptionId){
    var formData = new FormData();
    formData.append("prescriptionId", prescriptionId);
    formData.append("action", "upload");
    formData.append("fileDate", inputFile.lastModified);
    formData.append("fileFirstName", "");
    formData.append("fileLastName", "");
    formData.append("inputFileName", inputFile.name);
    formData.append("UpLoadedFile", inputFile);

    return ajaxcall("OrderPrescriptionFileManager","post",formData,true).then(function(data){
        console.log("File correctly uploaded");
    }).catch(function(err){
        console.log(err);
    });
}

//function for download the prescription
function downloadFilePrescription(fileName, prescriptionId){
    var parameters = {};
    parameters.action = "download";
    parameters.base64 = true;
    parameters.prescriptionId =  prescriptionId;
    parameters.inputFileName = fileName;

    return ajaxcall("OrderPrescriptionFileManager","post",parameters,false).then(function(data){
        return "data:image/png;base64," + data;
        
    }).catch(function(err){
        console.log(err);
    });
}

//function for add/modify the prescription
function AddPrescription(xmldoc){
    return  ajaxcall("OrderAddPrescription","post",xmldoc,false)
    .then(function(data){
        return data; 
    }).catch(function(err){
        console.log(err);
    });
}
//END

function defaultValue(value,def) {
    if (value === undefined || value === null || value === '' || 
            (value && Object.keys(value).length === 0 && Object.getPrototypeOf(value) === Object.prototype)) {
        return def;
    }
    return value;
}

function stringToBoolean(value) {
    return value != undefined && value != null && value.toLowerCase() === 'true';
}


jQuery.loadScriptByUrl = function (url, callback) {
    jQuery.ajax({
        url: url,
        dataType: 'script',
        success: callback,
        async: true
    });
}


